const USER_ID_KEY = 'smart-offers-user-id';

export class UserIdManager {
  private static generateUserId(): string {
    return `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  static getUserId(): string {
    if (typeof window === 'undefined') {
      return this.generateUserId();
    }

    try {
      let userId = localStorage.getItem(USER_ID_KEY);

      if (!userId) {
        userId = this.generateUserId();
        localStorage.setItem(USER_ID_KEY, userId);
      }

      return userId;
    } catch (error) {
      console.error('Error reading/writing userId to localStorage:', error);
      return this.generateUserId();
    }
  }

  static clearUserId(): void {
    if (typeof window === 'undefined') return;

    try {
      localStorage.removeItem(USER_ID_KEY);
    } catch (error) {
      console.error('Error clearing userId from localStorage:', error);
    }
  }
}
